import { useContext } from 'react';
import { DomainSoftBlockContext } from './DomainSoftBlockContextProvider';

export function useDomainSoftBlock() {
  return useContext(DomainSoftBlockContext);
}
